import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as moment from 'moment';
import { MeshServiceProvidor } from 'src/app/service/mesh/mesh.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { Router } from '@angular/router';
import { ToasterData } from 'src/app/shared/constants/constants';
import { CommonService } from '../../../shared/services/common/common.service';
@Component({
  selector: 'app-device-cyclecount',
  templateUrl: './device-cyclecount.component.html',
  styleUrls: ['./device-cyclecount.component.scss'],
})
export class DeviceCyclecountComponent implements OnInit, OnDestroy {
  @Input() cycleCountData;
  @Input() widget;
  @Input() type;
  public timeValue: any = moment().format('HH:mm:ss');
  subscriptionHandler = [];
  value: any;
  currentStatus = '';
  constructor(private service: MeshServiceProvidor, private router: Router) {}

  ngOnInit(): void {
    if (this.type !== 'template') {
      this.getData();
      this.symbolData();
    } else {
      this.value = 'Sample Text';
      this.timeValue = moment().format('HH:mm:ss');
    }
  }
  update = (data) => {
    if (data.value !== null) {
      this.value = data.value;
    }
    if (moment(data.timestamp).format('YYYY MM DD') === moment().format('YYYY MM DD')) {
      this.timeValue = moment(data.timestamp).format('HH:mm:ss');
    } else {
      this.timeValue = moment(data.timestamp).format('D MMM HH:mm:ss');
    }
  };
  getData() {
    const sub = this.service
      .getGaugeData(this.widget.currentPath, this.update)
      .then((res) => {
        if (res) {
          this.subscriptionHandler.push(res.gaugeDataInstance);
          if (res.initialValue !== null) {
            this.update(res.initialValue);
          }
        }
      })
      .catch((error) => {
        this.currentStatus = 'offline';
        this.subscriptionHandler = [undefined];
      });
  }
  border = (data) => {
    if (data.value !== null) {
      this.currentStatus = data.status;
    }
  };

  edit(type, data) {
    this.router.navigate(['/', 'main', 'template', 'editwidget'], {
      queryParams: {
        type,
        id: data.widgetID,
      },
    });
  }
  symbolData() {
    const subst = this.service
      .getGaugeData(this.widget.pointStatusPath, this.border, 'status')
      .then((res) => {
        if (res) {
          this.subscriptionHandler.push(res.gaugeDataInstance);
          if (res.initialValue !== null) {
            this.border(res.initialValue);
          }
        }
      })
      .catch((error) => {
        this.currentStatus = 'offline';
        this.subscriptionHandler = [undefined];
      });
  }

  destroy(e) {
    this.service.destroyGaugeData(e);
  }

  ngOnDestroy() {
    this.subscriptionHandler.forEach((value) => {
      if (value) {
        this.destroy(value);
      }
    });
  }
}
